var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7343_56283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.00183,
    r: 8,
    fill: "url(#paint0_linear_7343_56283)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8992 3.50183C5.12836 3.50183 4.29139 3.75606 3.6324 4.30338C2.95089 4.86941 2.5 5.71814 2.5 6.79291C2.5 7.53853 2.87115 8.25703 3.27347 8.84238C3.69317 9.45303 4.24326 10.0548 4.78777 10.5913C5.33616 11.1317 5.90258 11.6288 6.36801 12.0272C6.531 12.1668 6.67561 12.2893 6.80152 12.396C7.05591 12.6115 7.23398 12.7624 7.33314 12.8582L8 13.5018L8.66686 12.8582C8.76602 12.7624 8.94409 12.6115 9.19849 12.396L9.33936 12.2604L8 10.9601L7.97307 10.9373C7.85868 10.8404 7.739 10.7389 7.61873 10.636C7.16506 10.2476 6.63732 9.78365 6.13531 9.289C5.62942 8.79052 5.17288 8.28336 4.84855 7.81148C4.50683 7.3143 4.39655 6.97668 4.39655 6.79291C4.39655 6.26237 4.60216 5.92825 4.86163 5.71275C5.14363 5.47854 5.53211 5.35256 5.8992 5.35256C6.14341 5.35256 6.4314 5.43943 6.72368 5.59185C7.0127 5.74257 7.23652 5.92122 7.33314 6.01448L8 6.65815L8.66686 6.01448C8.76348 5.92122 8.9873 5.74257 9.27632 5.59185L7.99516 4.17834C7.87752 4.10315 7.7511 4.02922 7.61757 3.95958C7.16727 3.72476 6.56534 3.50183 5.8992 3.50183Z",
    fill: "url(#paint1_linear_7343_56283)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1008 3.50183C10.8716 3.50183 11.7086 3.75606 12.3676 4.30338C13.0491 4.86941 13.5 5.71814 13.5 6.79291C13.5 7.53853 13.1288 8.25703 12.7265 8.84238C12.3068 9.45303 11.7567 10.0548 11.2122 10.5913C10.6638 11.1317 10.0974 11.6288 9.63199 12.0272C9.469 12.1668 9.32439 12.2893 9.19848 12.396C8.94409 12.6115 8.76602 12.7624 8.66686 12.8582L8 13.5018L7.33314 12.8582C7.23398 12.7624 7.05591 12.6115 6.80151 12.396L6.72236 12.3289L8 10.9601L8.02693 10.9373C8.14132 10.8404 8.261 10.7389 8.38127 10.636C8.83494 10.2476 9.36268 9.78365 9.86469 9.289C10.3706 8.79052 10.8271 8.28336 11.1514 7.81148C11.4932 7.3143 11.6034 6.97668 11.6034 6.79291C11.6034 6.26237 11.3978 5.92825 11.1384 5.71275C10.8564 5.47854 10.4679 5.35256 10.1008 5.35256C9.85659 5.35256 9.5686 5.43943 9.27632 5.59185C8.9873 5.74257 8.76348 5.92122 8.66686 6.01448L8 6.65815L7.33314 6.01448C7.23652 5.92122 6.76823 5.63249 6.47921 5.48176L8.00484 4.17834C8.12248 4.10315 8.2489 4.02922 8.38243 3.95958C8.83273 3.72476 9.43466 3.50183 10.1008 3.50183Z",
    fill: "url(#paint2_linear_7343_56283)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7343_56283",
    x1: 16,
    y1: 8.00183,
    x2: 0,
    y2: 8.00183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7343_56283",
    x1: 4.61538,
    y1: 3.08898,
    x2: 7.44798,
    y2: 12.2118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7343_56283",
    x1: 9.69231,
    y1: 4.7404,
    x2: 8.88613,
    y2: 12.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7343_56283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00183105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientStaff);
export default __webpack_public_path__ + "static/media/patientStaff.296b9e43bbd51ce8faa8bca4e8bc84e2.svg";
export { ForwardRef as ReactComponent };